module.exports = __webpack_public_path__ + "static/commerce2x-merchant-59ac19e75ef3cc1d2768129d11730d92.png";